import { useMutation, useQueryClient } from '@tanstack/react-query';
import taskTemplateService from '@services/taskTemplate';
import { toast } from 'react-toastify';
import { TaskTemplateCreateInput } from '@models/taskTemplate.model';
import { TASK_TEMPLATES_QUERY_KEY } from './useTaskTemplates';
import { useTranslation } from '@hooks/useTranslation';

export const useCreateTaskTemplate = () => {
  const tActionMessages = useTranslation('actionMessages');
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ['createTaskTemplate'],
    mutationFn: async (input: TaskTemplateCreateInput) => {
      return await taskTemplateService.createTaskTemplate(input);
    },
    onSuccess: async () => {
      toast.success(tActionMessages.taskTemplateCreatedSuccessfully);
      await queryClient.invalidateQueries({ queryKey: [TASK_TEMPLATES_QUERY_KEY] });
    },
    onError: (error: any) => {
      toast.error(
        error?.response?.errors?.[0]?.message ||
          error?.message ||
          tActionMessages.failedToCreateTaskTemplate,
      );
    },
  });
};

export default useCreateTaskTemplate;
